module.exports = __webpack_public_path__ + "static/media/panasonic.ef5e039c.png";